import React, { useContext, useEffect, useState } from "react";
import { IToastContext, ToastContext } from "../../../providers/Toast";
import { useDispatch, useSelector } from "react-redux";
import { getSponsors } from "../../../context/sponsors/action";
import { SponsorsState } from "../../../context/sponsors/reducer";
import { ROUTES } from "../../../routing/routes";
import { composePathWithParams } from "../../../utils/url";
import { useHistory } from "react-router-dom";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
}

const SponsorsListView = ({ ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to the history instance that you may use to navigate.
  let history = useHistory();

  // Reference to Redux store dispatch function: use it to dispatch actions.
  const dispatch = useDispatch();

  // Access to toast manager hook that you may use to show toasts.
  const { openToast } = useContext<IToastContext>(ToastContext);

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------

  const [requested, setRequested] = useState<boolean>(false);

  // Pagination
  // const [lastItem, setLastItem] = useState<any>(null);
  // const [limit, setLimit] = useState<number>(DB_DEFAULTS.LIMIT);

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------
  const { sponsors, loading, error } = useSelector(
    ({ sponsorsReducer }: { sponsorsReducer: SponsorsState }) => {
      return sponsorsReducer;
    },
  );

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * Navigates to stand detail page
   * @function
   *
   * @param id
   */
  const goToStand = (id?: string) => {
    if (!id) {
      return;
    }

    history.push(composePathWithParams(ROUTES.STAND_DETAIL, [{ id: id }]));

    return;
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // init component
    console.log("[SponsorsListView] init");
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // destroy component
    console.log("[SponsorsListView] destroy");
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();

    return () => {
      destroy();
    };
  }, []);

  /**
   * Hook to sponsors in order to load them
   */
  useEffect(() => {
    if (!sponsors || !sponsors.length) {
      if (!requested) {
        dispatch(getSponsors());
        setRequested(true);
      }
    } else {
      console.log("[sponsors] already loaded");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sponsors]);

  /**
   * Hook to error in order to handle errors
   */
  useEffect(() => {
    if (!!error) {
      console.error(error);
      openToast({
        type: "error",
        title: "errors.general.title",
        message: "errors.general.description",
        callback: () => {
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <>
      {!!loading && (
        <div className="list-loading">
          <i className="fas fa-spin fa-spinner"></i>
        </div>
      )}
      {!loading && (
        <div className="sponsors">
          {sponsors.map((sponsor) => (
            <div className="sponsor" onClick={() => goToStand(sponsor.id)} key={sponsor.id}>
              <div
                style={{
                  backgroundImage: `url("${sponsor.image_url}")`,
                }}
              ></div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};
export default SponsorsListView;
